import React, { ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { signIn, signUp } from "../../providers/auth.provider";
import useTokenStorage from "../../hooks/userStorage";

import { useHistory, useLocation } from 'react-router-dom';
import { useIonRouter } from '@ionic/react'; // <-- Changed from useHistory

type UserDataInterface = {
  initialized: boolean;
  loggedIn: boolean;
  token: any;
};

type AuthContextInterface = {
  user?: any;
  isLoggedIn: boolean;

  isLoading: boolean;
  isPending: boolean;
  hasError: boolean;

  signInContext: (email: string, password: string) => void;
  signUpContext: (email: string, name: string, password: string) => void;
  signOutContext: () => void;

  state?: UserDataInterface;
};

const AuthContext = createContext<AuthContextInterface>({} as AuthContextInterface);

export function AuthProvider({ children }: { children: ReactNode }): JSX.Element {
  const { storedToken, setStoredToken, storeToken } = useTokenStorage();

  const [user, setUser] = useState<any>();
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(window.localStorage.getItem('token') != null);

  const [hasError, setHasError] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [loadingInitial, setLoadingInitial] = useState<boolean>(true);
  const history = useHistory();
  const router = useIonRouter(); 

  // const location = useLocation();

  // If we change page, reset the error state.
  // useEffect(() => {
  //   if (hasError) setHasError(null);
  // }, [location.pathname]);

  useEffect(() => {
    // setUser(user)
    // setLoadingInitial(false);
  }, []);

  function signInContext(email: string, password: string) {
    setIsLoading(true);

    signIn({ email, password }).then(async (response: any) => {      
      console.log("signInContext() response", response);
      handleLoginResponse(response);
    }).catch((error: any) => { setHasError(error) })
      .finally(() => { setIsLoading(false) });
  }

  function signUpContext(email: string, name: string, password: string) {
    setIsLoading(true);
    signUp({ email, name, password }).then((response: any) => {
      console.log("signUp() response", response);
      console.log("signUp() signing in", {email, password});
      signInContext(email, password)
    })
  }

  function handleLoginResponse(response:any){
      if (response.data.id) {
        
        setUser(response.data);
        storeToken(response.data.token);

        setIsLoading(false);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
  }

  function signOutContext() {


    setUser(undefined);
    storeToken(null);
    setIsLoading(false);
    setIsLoggedIn(false);
    window.localStorage.removeItem('token');

    /// Refresh app
    document.location.reload();
    // router.push("/login", "root", "replace"); 
    // history.push("/");

  }

  const memoedValue = useMemo(
    () => ({
      user,
      isLoggedIn,

      isLoading,
      isPending,
      hasError,

      signInContext,
      signUpContext,
      signOutContext
    }),
    [user, isLoading, isPending, hasError]
  );

  // We only want to render the underlying app after we
  // assert for the presence of a current user.
  return (
    // @ts-ignore
    <AuthContext.Provider value={ memoedValue }>
      {/*{!loadingInitial && children}*/}
      { children }
    </AuthContext.Provider>
  );
}

// Let's only export the `useAuth` hook instead of the context.
// We only want to use the hook directly and never the context component.
export default function useAuth() { return useContext(AuthContext); }
